export const COLOR_WHITE = '#fff';
export const COLOR_BLACK = '#000';
export const COLOR_GRAY = '#aaaaaa';
export const COLOR_OUTLINE_BLUE = '#3737e6';
export const COLOR_RED = '#ff0000';
export const COLOR_GRAY_BG = '#f9f9f9';

export const COLOR_ROOMS_RED = '#ff504e';
export const COLOR_WHATS_ON_BLUE = '#3ea9ff';
